import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorMasterBrandSearch = () => {
  const brandSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/master-brand/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { brandSearch }
}

export default InteractorMasterBrandSearch
